import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { Cell, Row, downloadSheets, generateSheet } from '../../../utils';
import XLSX, { Range } from 'xlsx-js-style';
import {
    Dropdown,
    DropdownButton,
    Row as BSRow,
    Table,
} from 'react-bootstrap';
import { AuthedLayout } from '../../../components';
import { ClassHDIDStatistic, GradeWHAvgStatistic, HDIDStatistic, UserInfo } from '../../../model';
import { useSemGrade } from '../../../hook';
import apis from '../../../apis';
import { toast } from 'react-toastify';


const HDID = {
    // Total: -9,
    UnderWeight: -1,
    Healty: 0,
    OverWeight: 1,
    Obesity: 2,
};

const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const fullBorderStyle = {
    top: borderStyle,
    bottom: borderStyle,
    left: borderStyle,
    right: borderStyle,
} as const;
const cellAlignStyle = {
    horizontal: 'center',
    vertical: 'center',
} as const;

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;

const whGradeStatistic: FunctionComponent<Props> = ({
    user,
    catchErrorForModal,
}) => {
    const { yearSem, element } = useSemGrade();
    const [datas, setDatas] = useState<GradeWHAvgStatistic[]>([]);
    const [userinfo, setUser] = useState<UserInfo>();
    useEffect(() => {
        if (yearSem) {
            apis.getUserInfo()
                .then((u) => {
                    setUser(u);
                })
                .catch(catchErrorForModal);
            toast
                .promise(
                    apis
                        .getWHGradeStatistic(yearSem.year, yearSem.sem)
                        .then(r => {
                            setDatas(r);
                        }),
                    {
                        pending: '資料載入中......',
                        success: '資料載入成功！',
                        error: '資料載入失敗！請查看錯誤資訊。',
                    }
                )
                .catch(catchErrorForModal);

        }
    }, [yearSem?.year, yearSem?.sem]);

    const gradeBase = datas.reduce((grades, d) => {
        return { ...grades, [d.grade]: [...(grades[d.grade] || []), d] };
    }, {} as Record<number, GradeWHAvgStatistic[]>);

    const totalHdidObj = {
        // [HDID.Total]: { hdid: HDID.Total, total: 0, male: 0, female: 0 },
        [HDID.Obesity]: { hdid: HDID.Obesity, total: 0, male: 0, female: 0 },
        [HDID.OverWeight]: {
            hdid: HDID.OverWeight,
            total: 0,
            male: 0,
            female: 0,
        },
        [HDID.Healty]: { hdid: HDID.Healty, total: 0, male: 0, female: 0 },
        [HDID.UnderWeight]: {
            hdid: HDID.UnderWeight,
            total: 0,
            male: 0,
            female: 0,
        },
    };
    // let classcount = 0;
    const contentRows: Row[] = Object.values(gradeBase).flatMap(
        (gs, idx, allArray) => {
            const gradeHDID = gs.reduce(
                (pv, g) => {
                    Object.values(g.hdids).forEach((h) => {
                        const hdid = pv[h.hdid];
                        if (hdid) {
                            hdid.total += h.total;
                            hdid.female += h.female;
                            hdid.male += h.male;
                        }
                        const totalHdid = totalHdidObj[h.hdid];
                        if (totalHdid) {
                            totalHdid.total += h.total;
                            totalHdid.female += h.female;
                            totalHdid.male += h.male;
                        }
                    });

                    return pv;
                },
                {
                    // [HDID.Total]: { hdid: HDID.Total, total: 0, male: 0, female: 0 },
                    [HDID.Obesity]: { hdid: HDID.Obesity, total: 0, male: 0, female: 0 },
                    [HDID.OverWeight]: {
                        hdid: HDID.OverWeight,
                        total: 0,
                        male: 0,
                        female: 0,
                    },
                    [HDID.Healty]: { hdid: HDID.Healty, total: 0, male: 0, female: 0 },
                    [HDID.UnderWeight]: {
                        hdid: HDID.UnderWeight,
                        total: 0,
                        male: 0,
                        female: 0,
                    },
                }

            );
            const rows = gs.flatMap((g, idx) => {
                return hdidToRows(
                    g.grade,
                    gradeHDID
                )
            });
            if (idx === allArray.length - 1) {
                const lastRow = rows[rows.length - 1];

                lastRow.cells = lastRow?.cells.map((c) => {
                    const { style: { border = {} } = {} } = c;
                    border.bottom = borderStyle;
                    c.style = { ...c.style, border };
                    return c;
                });
            }
            return rows;
        }
    );

    const content: Row[] = [
        {
            cells: [
                {
                    value: '年級 / 性別',
                    merge: { column: 3, row: 2 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '體位判讀',
                    merge: { column: 5, row: 1 },
                    style: { border: fullBorderStyle },
                },
            ],
        },
        {
            cells: [
                {
                    style: { border: fullBorderStyle },
                },
                {
                    style: { border: fullBorderStyle },
                },
                {
                    style: { border: fullBorderStyle },
                },
                {
                    value: '體位過輕',
                    merge: { column: 1, row: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '體位適中',
                    merge: { column: 1, row: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '體位過重',
                    merge: { column: 1, row: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '體位超重',
                    merge: { column: 1, row: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '合計',
                    merge: { column: 1, row: 1 },
                    style: { border: fullBorderStyle },
                },
            ],
        },
        ...contentRows,
        ...hdidToRows('全校合計', totalHdidObj),
    ];

    // const workSheet = generateSheet(content, { alignment: cellAlignStyle });
    const handleExcelDownload = () => {
        const workSheet = generateSheet(
            [
                {
                    cells: [
                        {
                            value: `${user.schools[user.currentSchool].name}${yearSem?.year}學年第${yearSem?.sem}學期_體位判讀結果統計報表(年級)`,
                            style: { alignment: { horizontal: 'left' } },
                        },
                    ],
                },
                ...content,
                {
                    cells: [
                        {
                            value:
                                '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                            style: { alignment: { horizontal: 'left' } },
                        },
                    ],
                },
            ],
            {
                alignment: cellAlignStyle,
            }
        );

        downloadSheets(
            '體位判讀結果統計報表(年級)',
            userinfo?.exportFileType,
            {
                sheet: workSheet,
                name: 'st',
            }
        );
    };

    const handlePrint = () => {
        const printWindow = window.open(
            '',
            '_blank',
            'width=1200,height=900'
        );

        if (!printWindow) {
            alert('瀏覽器阻擋了列印視窗，請允許彈出式視窗。');
            return;
        }

        const escapeHtml = (value: unknown): string => {
            return String(value ?? '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        };

        const title =
            `${user.schools[user.currentSchool].name}${yearSem?.year}學年第${yearSem?.sem}學期_體位判讀結果統計報表(年級)`;

        const tableRows = content
            .map((row) => {
                const cells = row.cells
                    .map((cell) => {
                        if (cell.value === undefined) {
                            return '';
                        }

                        const colSpan = cell.merge?.column
                            ? ` colspan="${cell.merge.column}"`
                            : '';

                        const rowSpan = cell.merge?.row
                            ? ` rowspan="${cell.merge.row}"`
                            : '';

                        return `
                        <td${colSpan}${rowSpan}>
                            ${escapeHtml(cell.value)}
                        </td>
                    `;
                    })
                    .join('');

                return `<tr>${cells}</tr>`;
            })
            .join('');

        printWindow.document.open();

        printWindow.document.write(`
        <!DOCTYPE html>
        <html lang="zh-Hant">
            <head>
                <meta charset="UTF-8" />
                <title>${escapeHtml(title)}</title>

                <style>
                    * {
                        box-sizing: border-box;
                    }

                    html,
                    body {
                        margin: 0;
                        padding: 0;
                        font-family:
                            "Microsoft JhengHei",
                            "Noto Sans TC",
                            Arial,
                            sans-serif;
                        color: #000;
                    }

                    .print-page {
                        min-height: 277mm;
                        display: flex;
                        flex-direction: column;
                    }

                    h1 {
                        margin: 0 0 12px;
                        text-align: center;
                        font-size: 18px;
                    }

                    table {
                        width: 100%;
                        border-collapse: collapse;
                        table-layout: fixed;
                    }

                    td {
                        border: 1px solid #000;
                        padding: 5px 3px;
                        text-align: center;
                        vertical-align: middle;
                        font-size: 11px;
                        word-break: break-word;
                    }

                    .footer {
    margin-top: auto;
    padding-top: 16px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

                    @page {
                        size: A4 portrait;
                        margin: 10mm;
                    }

                    @media print {
                        body {
                            padding: 0;
                        }

                        tr {
                            page-break-inside: avoid;
                            break-inside: avoid;
                        }
                    }
                </style>
            </head>

            <body>
                <div class="print-page">
                    <h1>${escapeHtml(title)}</h1>

                    <table>
                        <tbody>
                            ${tableRows}
                        </tbody>
                    </table>

                    <div class="footer">
    <span>承辦人:</span>
    <span>組長:</span>
    <span>主任:</span>
    <span>校長:</span>
</div>
                </div>

                <script>
                    window.onload = function () {
                        window.focus();

                        setTimeout(function () {
                            window.print();
                        }, 300);
                    };

                    window.onafterprint = function () {
                        window.close();
                    };
                </script>
            </body>
        </html>
    `);

        printWindow.document.close();
    };

    return (
        <AuthedLayout>
            <BSRow className="justify-content-between">
                <span className="mr-3">{element}</span>
                <DropdownButton
                    id="wh-grade-statistic-export"
                    title="匯出"
                    variant="success"
                    disabled={!datas.length}
                >
                    <Dropdown.Item onClick={handleExcelDownload}>
                        Excel 下載
                    </Dropdown.Item>

                    <Dropdown.Item onClick={handlePrint}>
                        列印
                    </Dropdown.Item>
                </DropdownButton>
            </BSRow>
            <hr />
            <BSRow>
                <Table
                    striped
                    bordered
                    className="text-center"
                    style={{ tableLayout: 'fixed' }}
                >
                    <colgroup>
                        <col style={{ width: '3%' }} />
                        <col style={{ width: '3%' }} />
                        <col style={{ width: '3%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                    </colgroup>
                    <tbody>
                        {content.map((r, i) => {
                            const cells = r.cells.map((c, j) =>
                                c.value != undefined ? (
                                    <td
                                        colSpan={c.merge?.column}
                                        rowSpan={c.merge?.row}
                                        key={`${i}-${j}`}
                                    >
                                        {c.value}
                                    </td>
                                ) : (
                                    <Fragment key={`${i}-${j}`}></Fragment>
                                )
                            );
                            return <tr key={i}>{cells}</tr>;
                        })}
                    </tbody>
                </Table>
            </BSRow>
        </AuthedLayout>
    );
};

function hdidToRows(
    grade: number | string,
    hdidObj: Record<number, HDIDStatistic>,
): Row[] {
    const totalCount = Object.values(hdidObj).reduce(
        (p, v) => {
            p.total += v.total;
            p.male += v.male;
            p.female += v.female;
            return p;
        },
        {
            total: 0,
            male: 0,
            female: 0,
        }
    );
    const gradeNo = [
        {
            value: grade,
            merge: { row: 6 },
            style: { border: fullBorderStyle },
        }
    ];

    return [
        {
            cells: [
                ...gradeNo,
                {
                    value: "男",
                    merge: { row: 2 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: "人數",
                    style: { border: fullBorderStyle },
                },
                ...[
                    HDID.UnderWeight,
                    HDID.Healty,
                    HDID.OverWeight,
                    HDID.Obesity,
                ].flatMap((hdid) => {
                    return [

                        {
                            value: hdidObj[hdid]?.male ?? 0,
                            style: { border: fullBorderStyle },
                        }

                    ] as Cell[];
                }),
                {
                    value: totalCount?.male ?? 0,
                    style: { border: fullBorderStyle },
                },
            ],

        },
        {
            cells: [
                {
                    style: { border: fullBorderStyle },
                },
                {
                    style: { border: fullBorderStyle },
                },
                {
                    value: "比率",
                    style: { border: fullBorderStyle },
                },
                ...[
                    HDID.UnderWeight,
                    HDID.Healty,
                    HDID.OverWeight,
                    HDID.Obesity,
                ].flatMap((hdid) => {
                    return [
                        {
                            value: percent(hdidObj[hdid]?.male ?? 0, totalCount.male),
                            style: { border: fullBorderStyle },
                        },
                    ] as Cell[];
                }),
                {
                    value: percent(totalCount.male ?? 0, totalCount.male),
                    style: { border: fullBorderStyle },
                },
            ],

        },
        {
            cells: [
                {
                    style: { border: fullBorderStyle },
                },
                {
                    value: "女",
                    merge: { row: 2 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: "人數",
                    style: { border: fullBorderStyle },
                },
                ...[
                    HDID.UnderWeight,
                    HDID.Healty,
                    HDID.OverWeight,
                    HDID.Obesity,
                ].flatMap((hdid) => {
                    return [

                        {
                            value: hdidObj[hdid]?.female ?? 0,
                            style: { border: fullBorderStyle },
                        }

                    ] as Cell[];
                }),
                {
                    value: totalCount?.female ?? 0,
                    style: { border: fullBorderStyle },
                },
            ],

        },
        {
            cells: [
                {
                    style: { border: fullBorderStyle },
                },
                {
                    style: { border: fullBorderStyle },
                },
                {
                    value: "比率",
                    style: { border: fullBorderStyle },
                },
                ...[
                    HDID.UnderWeight,
                    HDID.Healty,
                    HDID.OverWeight,
                    HDID.Obesity,
                ].flatMap((hdid) => {
                    return [
                        {
                            value: percent(hdidObj[hdid]?.female ?? 0, totalCount.female),
                            style: { border: fullBorderStyle },
                        },
                    ] as Cell[];
                }),
                {
                    value: percent(totalCount.female ?? 0, totalCount.female),
                    style: { border: fullBorderStyle },
                },
            ],
        },
        {
            cells: [
                {
                    style: { border: fullBorderStyle },
                },
                {
                    value: "小計",
                    merge: { row: 2 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: "人數",
                    style: { border: fullBorderStyle },
                },
                ...[
                    HDID.UnderWeight,
                    HDID.Healty,
                    HDID.OverWeight,
                    HDID.Obesity,
                ].flatMap((hdid) => {
                    return [

                        {
                            value: hdidObj[hdid]?.total ?? 0,
                            style: { border: fullBorderStyle },
                        }

                    ] as Cell[];
                }),
                {
                    value: totalCount?.total ?? 0,
                    style: { border: fullBorderStyle },
                },
            ],

        },
        {
            cells: [
                {
                    style: { border: fullBorderStyle },
                },
                {
                    style: { border: fullBorderStyle },
                },
                {
                    value: "比率",
                    style: { border: fullBorderStyle },
                },
                ...[
                    HDID.UnderWeight,
                    HDID.Healty,
                    HDID.OverWeight,
                    HDID.Obesity,
                ].flatMap((hdid) => {
                    return [
                        {
                            value: percent(hdidObj[hdid]?.total ?? 0, totalCount.total),
                            style: { border: fullBorderStyle },
                        },
                    ] as Cell[];
                }),
                {
                    value: percent(totalCount.total ?? 0, totalCount.total),
                    style: { border: fullBorderStyle },
                },
            ],
        },
    ];
}

function percent(value: number, denominator: number): string {
    if (!denominator) return '0.00%';
    return ((value / denominator) * 100).toFixed(2) + '%';
}

export const WHGradeStatistic = connector(whGradeStatistic);
